// eslint-disable no-underscore-dangle
import { configureStore, createImmutableStateInvariantMiddleware } from '@reduxjs/toolkit';
import { FLOPFLIP_STATE_SLICE, createFlopflipReducer } from '@flopflip/react-redux';
import { createBrowserHistory } from 'history';
// import { thunk, withExtraArgument } from 'redux-thunk';
import ServiceLayer from '../services/index';
import cas from './domains/cas/reducer';
import application from './domains/application/reducer';
import enumReducer from './domains/enum/reducer';
import contact from './domains/contact/reducer';
import document from './domains/document/reducer';
import csrf from './domains/csrf/reducer';
import defaultFlags from './defaultFeatureFlags';
import person from './domains/person/reducer';
import higherEds from './domains/organization/higher/reducer';
import creditsInfo from './domains/person/exam/reducer';
import citizenship from './domains/person/citizenship/reducer';
import certificate from './domains/person/certificate/reducer';
import associations from './domains/person/associations/reducer';
import military from './domains/person/military/reducer';
import secondaryEd from './domains/organization/secondary/reducer';
import employerDiscounts from './domains/organization/employerDiscounts/reducer';
import employerBenefits from './domains/organization/employer/reducer';
import task from './domains/saga/reducer';
import personTasks from './domains/saga/personTasks/reducer';
import user from './domains/iam/reducer';
import wallet from './domains/wallet/reducer';
import programofferingReducer from './domains/programoffering/reducer';
import genesysReducer from './domains/vendor/genesys/reducer';
import calculatorInput from './domains/financialaid/calculatorinput/reducer';
import calculatorSummary from './domains/financialaid/calculatorsummary/reducer';
import stackableSavings from './domains/financialaid/stackablesavings/reducer';
import financialSavings from './domains/financialaid/financialsavings/reducer';
import militaryBenefits from './domains/financialaid/militarybenefits/reducer';
import preferences from './domains/preferences/reducer';
import student from './domains/student/reducer';
import forgerock from './domains/forgerock/reducer';
import identityverify from './domains/person/identityverify/reducer';
import leads from './domains/leads/reducer';
import preloadedState from './preloadedState';
import oidc from './domains/auth0/oidcReducer';
import pricing from './domains/pricing/reducer';

export const history = createBrowserHistory({ basename: process.env.PUBLIC_URL });

const flopflipInitialState = {
  flags: defaultFlags,
  adapterIdentifiers: [],
  user: { id: 'anonymous' }
};

// Combine reducers
const rootReducer = {
  cas,
  csrf,
  person,
  military,
  higherEds,
  secondaryEd,
  creditsInfo,
  user,
  contact,
  application,
  enumReducer,
  document,
  task,
  personTasks,
  citizenship,
  certificate,
  associations,
  oidc, // Added compatibility reducer
  [FLOPFLIP_STATE_SLICE]: createFlopflipReducer(defaultFlags, flopflipInitialState),
  wallet,
  genesys: genesysReducer,
  programOfferingSearch: programofferingReducer,
  calculatorInput,
  calculatorSummary,
  stackableSavings,
  financialSavings,
  militaryBenefits,
  preferences,
  student,
  forgerock,
  employerDiscounts,
  employerBenefits,
  leads,
  identityverify,
  pricing,
};

// Create the Redux store
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      // ignoring all these nonserialized action checks for now to clear up console
      serializableCheck: {
        ignoredActions: [
          'services/SET_SERVICES', 
          'REQUEST_SAVED_PROGRAMS_ERROR',
          'REQUEST_IDENTITY_VERIFICATION_ERROR',
          'RECEIVE_IDENTITY_VERIFICATION',
          'REQUEST_EMPLOYER_BENEFIT_BY_DUNS_ERROR',
          'REQUEST_EMPLOYER_BENEFITS_BY_NAME_ERROR',
        ],
        ignoredPaths: [
          'services',
          'creditsInfo.creditsInfoStatus.errorData',
          'creditsInfo.creditsInfoStatus.errorData.config',
          'creditsInfo.creditsInfoStatus.errorData.config.adapter',
          'creditsInfo.error',
          'leads.savedProgramsStatus.errorData',
          'document.esignTranscriptTask',
          'pricing.employerBenefitByDunsStatus.errorData',
          'pricing.employerBenefitsByNameStatus.errorData',
        ],
      },
      thunk: {
        extraArgument: { Services: ServiceLayer }
      }
    })
    .concat(createImmutableStateInvariantMiddleware({
      warnAfter: 100
    })),
  preloadedState,
  devTools: process.env.NODE_ENV !== 'production' || 
    (typeof window !== 'undefined' && window.__ENV?.REACT_APP_ENV === 'stage'),
});

export default store;
